import PropTypes from "prop-types";
import styles from "./styles";
import FormLayout from "./containers/form-layout";

export default function App({ recaptchaSiteKey }) {
  return (
    <div className={styles.container}>
      <FormLayout recaptchaSiteKey={recaptchaSiteKey} />
    </div>
  );
}

App.propTypes = {
  recaptchaSiteKey: PropTypes.string.isRequired,
};
